/**
 * Window-level custom event names. Kept in a tiny shared module so
 * dispatchers (today `SearchFilters`) don't have to import the listener
 * component and pull its full module graph into unrelated bundles.
 */

/** Dispatched to ask the universal mobile search composer to open. */
export const SEARCH_COMPOSER_OPEN_EVENT = "easytiger:open-search-composer";

/**
 * Dispatched by PackageCard when the user clicks a package — the contact form
 * listens and pre-selects that service in its dropdown so the inquiry arrives
 * with the correct context. `event.detail.service` is the package name.
 */
export const CONTACT_PREFILL_SERVICE_EVENT = "easytiger:contact-prefill-service";

/** Detail payload for {@link CONTACT_PREFILL_SERVICE_EVENT}. */
export interface ContactPrefillServiceDetail {
  service: string;
}

/**
 * Dispatched by an APP-FRAME page whose inner panel scrolls while the document
 * does not (today: `/chat`). `NavScrollWrapper` hides and shows on `window`
 * scroll, which never fires there, so the nav sat permanently over a scrolling
 * thread. The frame reports its own scroll position instead.
 *
 * Only USER scrolls are reported: `/chat` pins itself to the bottom after every
 * turn, and a programmatic pin is a downward scroll that would otherwise hide
 * the nav on each new message.
 */
export const APP_FRAME_SCROLL_EVENT = "easytiger:app-frame-scroll";

/** Detail payload for {@link APP_FRAME_SCROLL_EVENT}. */
export interface AppFrameScrollDetail {
  /** Scroll offset of the inner panel, in px from its top. */
  y: number;
  /** px from the bottom of the panel's scroll range. */
  distanceFromBottom: number;
  /** The panel went away (the chat's empty state): show the nav and forget
   *  the scroll position, so the NEXT report seeds it again. Not a scroll. */
  reset?: boolean;
}
